import _get from 'lodash/get'

export const getScrollToTicketFormElement = errors => {
  let scrollTo = ''
  const displayName = _get(errors, 'displayName')
  const slotGroupName = _get(errors, 'slotGroupName')
  const faceValue = _get(errors, 'faceValue')
  const maxInventory = _get(errors, 'maxInventory')
  const stock = _get(errors, 'stock')
  const maxQuantity = _get(errors, 'maxQuantity')

  const description = _get(errors, 'description')
  const tags = _get(errors, 'tags')
  const flagHidden = _get(errors, 'flagHidden')
  const hideUnhideDate = _get(errors, 'hideUnhideDate')
  const flagTicketHasTimeSlots = _get(errors, 'flagTicketHasTimeSlots')
  const active = _get(errors, 'active')
  const flagSlidingScale = _get(errors, 'flagSlidingScale')
  const ticketHolds = _get(errors, 'ticketHolds')
  const ethereum = _get(errors, 'ethereum')
  const mainnet = _get(errors, 'mainnet')
  const polygon = _get(errors, 'polygon')
  const externalRedirect = _get(errors, 'externalRedirect')

  const salesEnd = _get(errors, 'salesEnd')
  const salesStart = _get(errors, 'salesStart')
  const ticketRules = _get(errors, 'ticketRules')
  // Check if there are any errors in ticketRules (nested structure like ticketRules.ticket_scan_rules[0].quantity)
  const hasTicketRulesErrors = ticketRules && (typeof ticketRules === 'object' && Object.keys(ticketRules).length > 0)

  if (displayName || faceValue || slotGroupName || maxInventory || stock || maxQuantity) {
    scrollTo = 'scroll-to-top'
  } else if (description) {
    scrollTo = 'scroll-to-description'
  } else if (hasTicketRulesErrors) {
    scrollTo = 'scroll-to-ticket-rules'
  } else if (
    flagHidden ||
    hideUnhideDate ||
    flagTicketHasTimeSlots ||
    active ||
    flagSlidingScale ||
    ticketHolds ||
    ethereum ||
    mainnet ||
    polygon ||
    externalRedirect
  ) {
    scrollTo = 'scroll-to-checkboxes'
  } else if (tags) {
    scrollTo = 'scroll-to-tags'
  } else if (salesStart || salesEnd) {
    scrollTo = 'scroll-to-dates'
  }

  return scrollTo
}
